import React from "react";
import { RouteComponentProps } from "react-router";
import { Link } from "react-router-dom";
import { V2 } from "../../Api";
import ToolbarMenuItem from "../ToolbarMenuItem";
import ViewToolbar from "../ViewToolbar";

import withTitle from "../withTitle";

interface IDataListListViewState {
    isLoading: boolean | string;

    lists: any[];
}

interface IDataListListViewProps extends RouteComponentProps<any> {

}

class DataListListView extends React.Component<IDataListListViewProps, IDataListListViewState> {
    constructor(props: Readonly<IDataListListViewProps>) {
        super(props);

        const state: IDataListListViewState = {
            isLoading: true,
            lists: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <ToolbarMenuItem>
                        <Link to="/data-lists/new" className="icon-plus" title="Create new list..." />
                    </ToolbarMenuItem>
                </ViewToolbar>
                <table className="table-vertical">
                    <thead>
                        <th>List name</th>
                        <th>Locator</th>
                    </thead>
                    <tbody>
                        {this.state.isLoading === true
                            ? <tr>
                                <td colSpan={10}>
                                    <div className="spinner lds-dual-ring" />
                                </td>
                            </tr>
                            : typeof this.state.isLoading === "string"
                                ? <tr>
                                    <td colSpan={10}>
                                        <span className="error-text">{this.state.isLoading}</span>
                                    </td>
                                </tr>
                                : this.state.lists.map(a => <tr key={a.id} className="clickable" onClick={() => this.goList(a.id)}>
                                    <td>{a.name}</td>
                                    <td>{a.resourceLocator}</td>
                                </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const listResult = await V2.get<any>(`list`);

            this.setState({
                isLoading: false,
                lists: listResult.lists
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load lists"
            });
        }
    }

    private goList(id: string) {
        this.props.history.push(`/data-lists/${id}`);
    }
}

export default withTitle("Data Lists", DataListListView);
